import { useContext, useEffect, useState } from 'react'
import './index.scss'
import AvatarDressup from './AvatarDressup'
import TalkSkill from './TalkSkill'
import CloudDressup from './CloudDressup'
import AvatarRender from './AvatarRender'
import CloudAnimation from './CloudAnimation'
import AvatarCreator from './AvatarCreator'
import { RendererContext } from '../FURenderkit'
import CloudRender from './CloudRender'
import { AvatarContext } from '../RenderComp/Avatar'
import { NavLink, Routes, Route } from "react-router-dom";
import NaviComp from '../NaviComp'
import EmptyRoute from './EmptyRoute'
import { RENDER_SDK } from '@/config'

type AvatarControllerProps = {
    [k: string]: any
}

const AvatarController = (props: AvatarControllerProps) => {
    const { renderer, comp } = useContext(RendererContext)
    const { avatar, avatarConfig } = useContext(AvatarContext)
    const [initDressupPart, setInitDressupPart] = useState('face')
    const [initDressupType, setInitDressupType] = useState('my')

    useEffect(() => {
        if (!comp && avatar) {
            // 返回菜单页时候手动清空canvas宽高方便重新resize
            RENDER_SDK.wasmCtx.module.canvas.width = "0"
            RENDER_SDK.wasmCtx.module.canvas.height = "0"
        }
        if (avatar) {
            const gender = avatarConfig?.data.gender as string
            const caseGender = gender.slice(0, 1).toUpperCase() + gender.slice(1).toLowerCase()
            avatar.setAnimationAsync(
                `GAssets/animation/Asia${caseGender}/common/ani_ptag_a${gender}_huxi.bundle`
            );
        }
        if (comp && renderer) {
            setTimeout(() => {
                renderer.resize()
            }, 300)
        }
    }, [comp, renderer])

    return (
        <div className='avatar-controller'>
            <Routes>
                <Route
                    path={process.env.REACT_APP_HOMEPAGE}
                    element={<NaviComp />}
                />
                <Route
                    path={`${process.env.REACT_APP_HOMEPAGE}/*`}
                    element={<EmptyRoute />}
                >
                    <Route
                        path='render'
                        element={<AvatarRender />}
                    />
                    <Route
                        path='dressup'
                        element={
                            <AvatarDressup
                                setInitDressupPart={setInitDressupPart}
                                setInitDressupType={setInitDressupType}
                            />
                        }
                    />
                    <Route
                        path='tts'
                        element={
                            <TalkSkill />
                        }
                    />
                    <Route
                        path='material'
                        element={
                            <CloudDressup
                                initDressupPart={initDressupPart}
                                initDressupType={initDressupType}
                                setInitDressupPart={setInitDressupPart}
                                setInitDressupType={setInitDressupType}
                            />
                        }
                    />
                    <Route
                        path='animation'
                        element={(
                            <CloudAnimation />
                        )}
                    />
                    <Route
                        path='creator'
                        element={(
                            <AvatarCreator />
                        )}
                    />
                    <Route
                        path='cloud_render/*'
                        element={(
                            <CloudRender />
                        )}
                    />
                </Route>
            </Routes>

        </div>
    )
}

export default AvatarController
